export default __webpack_public_path__ + "static/mo-logo-0ed61ca0b7c01d0aa3c6b07a8c673100.svg";